__turbopack_context__.v({
  "embeddedEntry": "BlockVideo-module-scss-module__4M-2-G__embeddedEntry",
  "flushBottom": "BlockVideo-module-scss-module__4M-2-G__flushBottom",
  "flushTop": "BlockVideo-module-scss-module__4M-2-G__flushTop",
  "inner": "BlockVideo-module-scss-module__4M-2-G__inner",
  "insert": "BlockVideo-module-scss-module__4M-2-G__insert",
  "videoBlock": "BlockVideo-module-scss-module__4M-2-G__videoBlock",
});
